import React, { Component } from "react";
import * as d3 from "d3";
import { Link } from "gatsby";
import Header from "../components/header";
import NavBar from "../components/navbar";
import ReactMarkdown from "react-markdown";
import ReactPlayer from "react-player"
import "../styles/github.css";
const gfm = require("remark-gfm");

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = { terms: null };
  }

  componentDidMount() {
    // fetch(
    //   "https://raw.githubusercontent.com/KKulma/climate-change-data/master/README.md"
    // )
    //   .then((r) => r.text())
    //   .then((i) => {
    //     this.setState({ terms: i });
    //   });
  }
  render() {
    return (
      <div>
        <NavBar />
        <div className="bg-light">
          <div className="container">
            <Header headerText="MonkCode" tagLine="Climate research..." />
          </div>
        </div>
        <div className="container">
          <h1>Climate Science</h1>
          <h2>Data Sources</h2>
          <a href="https://data.giss.nasa.gov/">NASA</a> National Aeronautics and Space Administration<br />Goddard Institute for Space Studies<br /><br />
          <a href="https://www.ncei.noaa.gov/products">NOAA</a> National Centers for Environmental Information<br />National Oceanic and Atmospheric Administration<br /><br />
          <a href="https://nsidc.org/home">NSIDC</a> National Snow and Ice Data Center<br />a part of CIRES at the University of Colorado Boulder<br /><br />
          <h2>Scientists</h2>
          <a href="https://www.reuters.com/investigates/section/climate-change-scientists/">Reuters top 1000 Scientists</a>
          <h2>YouTube</h2>
          <ReactPlayer url="https://youtu.be/wkqDJwTIg_E?si=gRMTwhfjoEwE3bgq" />
          {/* <ReactMarkdown plugins={[gfm]} children={this.state.terms} /> */}
          <Link to="/sitemap-pages.xml">Sitemap Pages</Link>
        </div>
      </div>
    );
  }
}
export default Home;
